import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { ServiceTemplateScheduleOccurrencesColumn } from "@common/types/views/serviceTemplateScheduleOccurrencesView";

// Read-only preview table (no persistence, no column configuration) used by
// the schedule wizard's first step — dates only, since no real occurrence
// records (roles/status/actions) exist yet for an unsaved schedule.
export const serviceTemplateScheduleOccurrencesView: View = {
    type: ViewType.SERVICE_TEMPLATE_SCHEDULE_OCCURRENCES,
    columns: [
        { id: ServiceTemplateScheduleOccurrencesColumn.INDEX },
        { id: ServiceTemplateScheduleOccurrencesColumn.APPLICATION_DATE },
        { id: ServiceTemplateScheduleOccurrencesColumn.SERVICE_START },
        { id: ServiceTemplateScheduleOccurrencesColumn.SERVICE_END },
        { id: ServiceTemplateScheduleOccurrencesColumn.WORK_START },
        { id: ServiceTemplateScheduleOccurrencesColumn.WORK_END },
    ],
    filters: {},
    options: { density: ViewDensity.MD },
};

// Full view for the "Upcoming occurrences" drawer, where occurrences are real
// persisted records with role assignments and an actionable status. Work
// dates, Manager, and Client contact are omitted — the drawer has no
// ColumnSettings, so a slim layout avoids forcing horizontal scroll before
// Status/Actions. Manager/Client can still be set via bulk actions.
export const serviceTemplateScheduleOccurrencesDrawerView: View = {
    type: ViewType.SERVICE_TEMPLATE_SCHEDULE_OCCURRENCES,
    columns: [
        {
            id: ServiceTemplateScheduleOccurrencesColumn.INDEX,
            options: { pin: "left" },
        },
        { id: ServiceTemplateScheduleOccurrencesColumn.APPLICATION_DATE },
        { id: ServiceTemplateScheduleOccurrencesColumn.SERVICE_START },
        { id: ServiceTemplateScheduleOccurrencesColumn.SERVICE_END },
        { id: ServiceTemplateScheduleOccurrencesColumn.PREPARER },
        { id: ServiceTemplateScheduleOccurrencesColumn.REVIEWER },
        { id: ServiceTemplateScheduleOccurrencesColumn.ESTIMATED_TIME },
        {
            id: ServiceTemplateScheduleOccurrencesColumn.STATUS,
            options: { pin: "right" },
        },
        {
            id: ServiceTemplateScheduleOccurrencesColumn.ACTIONS,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: { density: ViewDensity.MD },
};
